import { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useSubscriptionTier } from '../../utils/hooks/useSubscriptionTier';
export function useTierPromotionCardCtaType(deviation) {
    var _a;
    var _b = useSubscriptionTier(deviation), isUserSubscribed = _b.isUserSubscribed, isOwner = _b.isOwner;
    var isMobile = useContext(MobileContext);
    if (isOwner) {
        if (isMobile) {
            return;
        }
        return 'edit';
    }
    if (isUserSubscribed) {
        return 'view-subscribed';
    }
    if (!((_a = deviation.tier) === null || _a === void 0 ? void 0 : _a.canUserSubscribe)) {
        return 'disabled';
    }
    return 'subscribe';
}
//# sourceMappingURL=useTierPromotionCardCtaType.js.map